import content from "../../../config/content.json";
import {
	TitleAndContentProps,
	VideoSectionProps,
} from "../../../constants/pageSectionTypes";
import useScreenSize from "../../../hooks/useScreenSize";
import { Container } from "../../common/Container/Container";
import Hero, { HeroContent } from "../../common/Hero/Hero";
import { HighlightedTableContent } from "../../common/HighlightedTable/HighlightedTable";
import MainCallToAction, {
	MainCallToActionContent,
} from "../../common/MainCallToAction/MainCallToAction";
import VideoSection from "../../common/VideoSection/VideoSection";
import malePilot from "../../imagenes/about-us/AboutPage_Story.png";
import about03 from "../../imagenes/about-us/AboutUs_OurStory2_250.png";
import about01 from "../../imagenes/about-us/AboutUs_OurStory_220KB.png";
import memories from "../../imagenes/about-us/AboutUs_OurStory_250KB.png";
import bgImageDesktop from "../../imagenes/about-us/About_Horizontal.webp";
import bgImageMobile from "../../imagenes/about-us/Mobile_About_150kb.png";
import "./about.scss";
import OurApproach from "./sections/OurApproach/OurApproach";
import OurFramework, {
	ColumnHeader,
} from "./sections/OurFramework/OurFramework";
import OurStory from "./sections/OurStory/OurStory";
import OurValues, { OurValuesContent } from "./sections/OurValues/OurValues";
import UrgencyData, {
	UrgencyDataContent,
} from "./sections/UrgencyData/UrgencyData";
import WhyNow from "./sections/WhyNow/WhyNow";

const aboutImagesMap = {
	About_01: about01,
	About_02: malePilot,
	About_03: about03,
	About_04: memories,
};

const AboutUs = () => {
	const { width } = useScreenSize();
	const isMobile = width < 768;
	const isTabletOrLarger = width >= 768;
	const page = content.pages["about-us"];

	const hero = page.hero as HeroContent;
	const urgencyData = page.urgencyData as UrgencyDataContent;
	const mainCallToAction = page.mainCallToAction as MainCallToActionContent;
	const whyNow = page.whyNow as TitleAndContentProps;
	const ourApproach = page.ourApproach as TitleAndContentProps;
	const ourStory = page.ourStory as TitleAndContentProps;
	const ourValues = page.ourValues as OurValuesContent;
	const ourFramework =
		page.ourFramework as HighlightedTableContent<ColumnHeader>;
	const ourName = page.ourName as VideoSectionProps;

	return (
		<Container className="about-us" headerWithTransparentBackground>
			<Hero
				sectionContent={hero}
				isMobile={isMobile}
				mediaMap={aboutImagesMap}
				bgImageMobile={bgImageMobile}
				bgImageDesktop={bgImageDesktop}
				hideMedia={isTabletOrLarger}
			/>
			<div className="content-container">
				<OurApproach sectionContent={ourApproach} />
				<div className="row row--column-start row--large-screen-reverse why-now-and-urgency-data">
					<WhyNow sectionContent={whyNow} className="column" />
					<UrgencyData sectionContent={urgencyData} className="column" />
				</div>
				<OurStory sectionContent={ourStory} />
				<OurFramework sectionContent={ourFramework} isMobile={isMobile} />
			</div>
			<div className="gradient">
				<div className="content-container">
					<OurValues sectionContent={ourValues} />
					<VideoSection sectionContent={ourName} className="our-name" />
				</div>
			</div>
			<MainCallToAction sectionContent={mainCallToAction} isMobile={isMobile} />
		</Container>
	);
};

export default AboutUs;
